import { useEffect, useState } from 'react';
import { ScoringMatrixService } from '@/services/ChatScoringMatrixService';

const useChatScoringMatrix = ({ recruitmentId, enabled }) => {
    const [matrix, setMatrix] = useState(null);

    useEffect(() => {
        if (!enabled || !recruitmentId) return undefined;
        let cancelled = false;
        ScoringMatrixService.getForRecruitment(recruitmentId)
            .then(data => { if (!cancelled) setMatrix(data); })
            .catch(() => { if (!cancelled) setMatrix(null); });
        return () => { cancelled = true; };
    }, [enabled, recruitmentId]);

    return matrix?.enabled ? matrix : null;
};

export default useChatScoringMatrix;
